<template>
    <div class="p-3">
        <el-card header="Transportadoras">
            <ElForm ref="formRef" label-position="top" inline :model="searchData" :rules="rules">
                <ElFormItem label="pesquisar empresas de transporte" class="col-12 col-md-4 col-lg-3" prop="q">
                    <ElInput name="q" v-model="searchData.q" />
                </ElFormItem>

                <ElFormItem label="buscar">
                    <ElButton :loading="loading" type="primary" @click="search">Procurar</ElButton>
                </ElFormItem>
            </ElForm>
            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
            ]" :data="data" >
                <el-table-column label="Local" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.description.substring(0, 20) }}...
                    </template>
                </el-table-column>
                <el-table-column label="Local" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.area.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Adicionada em" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ new Date(data.row.created_at).toLocaleString("pt") }}
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" tag="router-link" :to="'/companies/' + data.row.id" icon="View" title="Ver mais"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PersonalTable>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount, reactive, ref } from 'vue'
    import { ElMessageBox, ElForm, ElFormItem, ElInput, ElButton, FormInstance, FormRules } from 'element-plus';
    import { useStore } from 'vuex';
    import { TravelCompany } from '@/services/types';

    const loading = ref<boolean>(true)
    const data = ref<Array<TravelCompany>>([])
    const formRef = ref<FormInstance>()

    const rules = reactive<FormRules<{q: string, dates: Array<string>}>>({
        q: [{required: false, message: 'Selecione a imagem'}],
    })

    const searchData = reactive<{q: string, dates: Array<string>}>({q: '', dates: []})

    const getCompanies = async (q: string | false = false) => {
        loading.value = true
        const params = new URLSearchParams()
        if (q && q.trim().length > 0) {
            params.append('q', q)
        } 
        const res = await Api.get(`admin/travel-companies?${params.toString()}`)
        if (res.status == 200) {
            console.log(res.data)
            data.value = res.data.companies
        } else {
            console.log(res)
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }

    const search = async () => {
        loading.value = true
        await getCompanies(searchData.q)
    }
    onBeforeMount(async () => {
        await getCompanies()
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 6) {
            // new product
            await getCompanies()
        }
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
